import request from '../utils/request'

// 我的评分任务清单（含已评回显）
export function getMyTasks(year, season) {
  return request({
    url: '/perf/my-tasks',
    method: 'get',
    params: { year, season }
  })
}

// 提交一笔评分（重复提交覆盖）
export function submitScore(data) {
  return request({
    url: '/perf/score',
    method: 'post',
    data
  })
}

// 定量数据行列表（仅含已保存过数据的部门；每行带该部门 A/B 占比）
export function getQuantList(year, season) {
  return request({
    url: '/perf/quant',
    method: 'get',
    params: { year, season }
  })
}

// 定量数据行保存（deptId 必填=被考核部门；目标值/实际值 + 两项占比同事务写入）
export function saveQuant(data) {
  return request({
    url: '/perf/quant',
    method: 'post',
    data
  })
}

// 计算部门/人员结果（可重复执行，覆盖重算）
export function calcResults(year, season) {
  return request({
    url: '/perf/calc',
    method: 'post',
    params: { year, season }
  })
}

// 部门结果：season=1-4季度；season=0或不传=年度平均
export function getDeptResults(year, season) {
  return request({
    url: '/perf/dept-results',
    method: 'get',
    params: season === undefined || season === null || season === '' ? { year } : { year, season }
  })
}

// 人员结果：支持 deptId 过滤；season=0或不传=年度平均
export function getEmpResults(year, season, deptId) {
  const params = { year }
  if (season !== undefined && season !== null && season !== '') params.season = season
  if (deptId) params.deptId = deptId
  return request({
    url: '/perf/emp-results',
    method: 'get',
    params
  })
}

// 考核期列表（含开启状态，年季倒序）
export function getPeriods() {
  return request({
    url: '/perf/periods',
    method: 'get'
  })
}

// 开启/关闭考核期（开启互斥：自动关闭其他开启中的期次）
export function savePeriod(data) {
  return request({
    url: '/perf/period',
    method: 'post',
    data
  })
}

// 定量数据行的部门下拉选项（被考核部门）
export function getQuantDepts() {
  return request({
    url: '/perf/quant-depts',
    method: 'get'
  })
}

// 删除一个部门的定量数据行（含占比配置与该部门全部期次数据，不可恢复）
export function deleteQuantRow(deptId) {
  return request({
    url: '/perf/quant-row',
    method: 'delete',
    params: { deptId }
  })
}

// 打分进度统计（管理员视角）：每人应打/已打/分场景明细 + 按部门汇总
export function getProgress(year, season) {
  return request({
    url: '/perf/progress',
    method: 'get',
    params: { year, season }
  })
}

// 当前用户的结果页查看范围（admin/deptLeader/employeeId/deptId/deptName）：控制计算按钮、部门分节与明细列显隐
export function getPerfViewScope() {
  return request({
    url: '/perf/view-scope',
    method: 'get'
  })
}
